module.exports = __webpack_public_path__ + "static/media/AudienceInterest-en.038412e6.jpg";